// leagueDefaults.js — "did the user ever set up their league?" in one place.
//
// Both sides need this answer and they must not disagree: the client stamps a
// leagueClass onto each draft log, and the Discord embed (api/draft-log.js)
// falls back to computing it for logs from builds that predate that field.
// Two copies of the comparison would drift, so there is exactly one.
//
// Zero dependencies beyond the defaults themselves — no React, no network — so
// the browser bundle and the serverless function can both import it.

import { DEFAULT_SCORING, DEFAULT_SETTINGS } from '../data/scoring.js';

/**
 * True only when teams, budget, every roster slot AND every supplied scoring
 * key match the shipped defaults — i.e. the settings are untouched.
 *
 * Scoring keys the settings object omits do NOT count as customization: draft
 * logs and saved leagues carry partial scoring objects, and a missing key means
 * "unset", not "changed".
 *
 * @param {Object} s A settings object ({teams, budget, positions, scoring}).
 * @returns {boolean}
 */
export function isDefaultLeague(s) {
  if (!s || typeof s !== 'object') return false;
  if (Number(s.teams) !== DEFAULT_SETTINGS.teams) return false;
  if (Number(s.budget) !== DEFAULT_SETTINGS.budget) return false;

  const pos = s.positions || {};
  const posKeys = new Set([...Object.keys(DEFAULT_SETTINGS.positions), ...Object.keys(pos)]);
  for (const k of posKeys) {
    if ((Number(pos[k]) || 0) !== (DEFAULT_SETTINGS.positions[k] || 0)) return false;
  }

  const sc = s.scoring || {};
  return !Object.keys(DEFAULT_SCORING).some((k) => sc[k] !== undefined && sc[k] !== DEFAULT_SCORING[k]);
}
